import { render, staticRenderFns } from "./FileError.vue?vue&type=template&id=7680a876&scoped=true"
import script from "./FileError.vue?vue&type=script&lang=js"
export * from "./FileError.vue?vue&type=script&lang=js"
import style0 from "./FileError.vue?vue&type=style&index=0&id=7680a876&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7680a876",
  null
  
)

export default component.exports